// CANONICAL COPY (GH #7115). src/constants/obligations/obl-management-commitment.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-management-commitment',
  title: 'Verify management commitment to information security',
  description:
    'Confirm that management requires all personnel to apply information security in accordance with established policies. Evidence includes policy acknowledgements and management review minutes.',
  category: 'governance',
  scfIds: ['SCF-GOV-004'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Management commitment policy is published' },
    { type: 'document-acknowledged', description: 'Personnel have acknowledged the policy' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
